module.exports = "pegasus/assets/image-text-button-share-preview.png";